import { api } from '../api';
import { getToken } from "../auth";

export const postCreateRegister = (data) => {
    return api({
        url: "/call-register",
        method: "POST",
        headers: {
            Authorization: "Bearer " + getToken()
        },
        data: data
    }).then(response => response)
        .catch(error => {
            if (error.response) {
                return error.response
            } else if (error.request) {
                return error.request
            } else {
                console.log('Error', error.message);
                return error.message
            }
        });
};

export const patchNotAnswer = (registerId) => {
    return api({
        url: "/call-register/not-answer/" + registerId,
        method: "PATCH",
        headers: {
            Authorization: "Bearer " + getToken()
        },
    }).then(response => response)
        .catch(error => {
            if (error.response) {
                return error.response
            } else if (error.request) {
                return error.request
            } else {
                console.log('Error', error.message);
                return error.message
            }
        });
};